module.exports = __webpack_public_path__ + "img/update-app-2.6f7456e9.png";